/* eslint-disable import/prefer-default-export */
import history from './history';

export const afterLogOut = () => {
  sessionStorage.clear();
  history.replace('/login');
};
